import React from "react";
import { View, StyleSheet } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";
import Shadow from "components/Shadow";

import { colors, sizes, strings } from "assets/constants";

const UserCard: React.FC<{ user: UserT }> = ({ user }) => {
  return (
    <Shadow style={styles.card}>
      <View style={styles.iconContainer}>
        <Icon size={40} type="fontAwesome" name="user-o" />
      </View>
      <View style={styles.content}>
        <View>
          <Text weight="bold"> {user?.name} </Text>
          <Text color={colors.dark._08} size={"sm"} weight="extraBold">
            {" "}
            {user?.mobile}{" "}
          </Text>
        </View>

        <View style={styles.footer}>
          <Text> {user?.roles?.[0]?.name}</Text>
          <Text>ِ</Text>
          <Text> {user?.company?.[0]?.name} </Text>
        </View>
      </View>
    </Shadow>
  );
};

export default UserCard;

const styles = StyleSheet.create({
  card: {
    width: "100%",
    overflow: "hidden",
    flexDirection: "row-reverse",
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.white,
  },

  iconContainer: {
    width: 90,
    height: 90,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: sizes.space / 2,
    backgroundColor: colors.dark._13,
  },

  footer: { flexDirection: "row-reverse" },

  content: {
    justifyContent: "space-between",
    paddingVertical: sizes.space / 2,
  },
});
